import type { EquipmentStore } from '../types'

export const selectBuilder = (state: EquipmentStore) => ({
  builderHeaderDistanceToTop: state.builderHeaderDistanceToTop,
  activeStep: state.activeStep,
  stepsWithError: state.stepsWithError
})

export const selectBuilderActions = (state: EquipmentStore) => ({
  setBuilderHeaderDistanceToTop: state.setBuilderHeaderDistanceToTop,
  setActiveStep: state.setActiveStep,
  goNextStep: state.goNextStep,
  goPrevStep: state.goPrevStep,
  resetBuilder: state.resetBuilder,
  setStepsWithError: state.setStepsWithError,
  setSectionsErrors: state.setSectionsErrors
})

export const selectFactoryFits = (state: EquipmentStore) => ({
  archivedFactoryFits: state.archivedFactoryFits,
  factoryFitsChecked: state.factoryFitsChecked
})

export const selectFactoryFitsActions = (state: EquipmentStore) => ({
  setArchivedFactoryFits: state.setArchivedFactoryFits,
  setFactoryFitsChecked: state.setFactoryFitsChecked,
  toggleFactoryFitChecked: state.toggleFactoryFitChecked,
  archiveFactoryFit: state.archiveFactoryFit,
  onRemoveArchivedFactoryFit: state.onRemoveArchivedFactoryFit,
  resetFactoryFits: state.resetFactoryFits
})

export const selectDealerFits = (state: EquipmentStore) => ({
  dealerFitsChecked: state.dealerFitsChecked,
  selectedDealerOptions: state.selectedDealerOptions
})

export const selectDealerFitsActions = (state: EquipmentStore) => ({
  setDealerFitsChecked: state.setDealerFitsChecked,
  toggleDealerFitChecked: state.toggleDealerFitChecked,
  setSelectedDealerOptions: state.setSelectedDealerOptions,
  onRemoveArchivedDealerOption: state.onRemoveArchivedDealerOption,
  resetDealerFits: state.resetDealerFits
})

export const selectWarranty = (state: EquipmentStore) => ({
  useBrandWarranty: state.useBrandWarranty,
  rulesToBeApplied: state.rulesToBeApplied
})

export const selectWarrantyActions = (state: EquipmentStore) => ({
  setUseBrandWarranty: state.setUseBrandWarranty,
  setRulesToBeApplied: state.setRulesToBeApplied
})

export const selectUI = (state: EquipmentStore) => ({
  expandedFamilies: state.expandedFamilies,
  sectionsErrors: state.sectionsErrors
})

export const selectUIActions = (state: EquipmentStore) => ({
  setExpandedFamilies: state.setExpandedFamilies,
  setExpandedFamiliesByKey: state.setExpandedFamiliesByKey,
  closeExpandedFamily: state.closeExpandedFamily,
  setSectionsErrors: state.setSectionsErrors,
  resetUi: state.resetUi
})

export const selectTransportType = (state: EquipmentStore) => ({
  selectedTransportType: state.selectedTransportType
})

export const selectTransportTypeActions = (state: EquipmentStore) => ({
  setSelectedTransportType: state.setSelectedTransportType
})

export const selectServiceContract = (state: EquipmentStore) => ({
  selectedServiceContract: state.selectedServiceContract
})

export const selectServiceContractActions = (state: EquipmentStore) => ({
  setSelectedServiceContract: state.setSelectedServiceContract
})
